import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStorybook16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconStorybook16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m10.302 3.475.06-1.355-.005-.01-6.6.415a.6.6 0 0 0-.565.635l.375 9.9a.6.6 0 0 0 .575.58l8.05.36a.6.6 0 0 0 .63-.6V2.6a.6.6 0 0 0-.64-.6l-.665.05.05 1.38a.09.09 0 0 1-.14.07l-.45-.35-.53.4a.09.09 0 0 1-.145-.075M8.827 6.653V6.65v.005zm1.794-.043c-.214.16-1.782.274-1.794.043.029-.898-.37-.933-.596-.933-.205 0-.565.065-.565.55 0 .487.52.762 1.131 1.085.868.46 1.92 1.015 1.92 2.415 0 1.345-1.09 2.09-2.486 2.09-1.435 0-2.685-.585-2.55-2.6.06-.24 1.885-.18 1.885 0-.025.835.17 1.08.65 1.08.365 0 .525-.2.525-.55 0-.516-.541-.82-1.164-1.17-.843-.473-1.836-1.03-1.836-2.31 0-1.285.875-2.145 2.45-2.145 1.57 0 2.43.845 2.43 2.445"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStorybook16);
